import { Component, Input, OnInit } from '@angular/core';
import { SummaryStageDto } from '../../data/CommandServiceDtos.generated';

@Component({
  selector: 'project-cxplanner-stage',
  templateUrl: './project-cxplanner-stage.component.html',
  styleUrls: ['./project-cxplanner-stage.component.scss']
})
export class ProjectCxplannerStageComponent implements OnInit {
  @Input() stage: SummaryStageDto;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/project-cxplanner-stage/project-cxplanner-stage.component.ts